export const routes = {
    DEFAULT: "/",
    DASHBOARD:"/dashboard",
    MERCHANT:"/merchants",
    MERCHANTDETAILS:"/merchant-details",
    VERIFYMERCHANTS:"/verify-merchant",
    BLOCKMERCHANTS:'/block-merchant',
    VERIFIERS:'/verifiers',
    VERIFIERMERCHANTPROFILE:'/verifiers-merchant',
    LOGIN:'/login',
    COLLECTIBLES:'/total-collectibles'
};